<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                         
                    <div class="mt--2 pb-2">
                         <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                    <!-- <button 
                        type="button"    
                        @click="hasHistory() 
                            ? $router.go(-1) 
                            : $router.push('/')" class="btn btn-secondary">&laquo; 
                            {{$t('message.backtap')}}
                    </button> -->
                  </div>  
                    <div> 
                        <h3 class="text-center">{{ $t('message.explication') }}</h3>
                    </div>
            </div>

            <div class="" v-if="mCommandes.length >0">
                <b-form  @reset="onReset">
                    <b-container class="mx-0 m-md-auto addpatient">
                        <fieldset class="py-2 px-0 p-md-2">
                            <legend  class="w-auto title text-center"> {{$t('message.patientinfo')}} </legend>
                            <b-row>

                                <b-col sm="6">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="lastName-group"
                                            :label="$t('message.lastName')"
                                            label-for="nom"
                                            description="">
                                        <b-form-input
                                                id="nom"
                                                v-model="$v.form.nom.$model"
                                                :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                                                type="text"
                                                required
                                                placeholder=""
                                                @focus="clearErrorField('nom')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.nom.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                            {{ getErrorsField('nom') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>

                                </b-col>

                                <b-col sm="6">

                                    <b-form-group
                                            id="lastName-group"
                                            :label="$t('message.firstName')"
                                            label-for="nom"
                                            description=""
                                    >
                                        <b-form-input
                                                id="nom"
                                                v-model="$v.form.prenom.$model"
                                                :state="$v.form.prenom.$dirty ? !(errorshasField('prenom') || $v.form.prenom.$error) : null"
                                                type="text"
                                                placeholder=""
                                                @focus="clearErrorField('prenom')"
                                        ></b-form-input>

                                        <!--                                    <b-form-invalid-feedback v-if="!$v.form.prenom.required">-->
                                        <!--                                        {{ $t('message.requiredField') }}-->
                                        <!--                                    </b-form-invalid-feedback>-->

                                        <b-form-invalid-feedback v-if="errorshasField('prenom')">
                                            {{ getErrorsField('prenom') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>

                                </b-col>

                            </b-row>

                            <b-row>
                                <b-col sm="6">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="telephone-group"
                                            :label="$t('message.phoneNumber')"
                                            label-for="telephone">
                                     
                                        <vue-tel-input 
                                            v-model="$v.form.telephone.$model" 
                                            :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null">
                                        </vue-tel-input>


                                        <b-form-invalid-feedback v-if="!$v.form.telephone.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>
    <!--                                    <b-form-invalid-feedback v-if="!$v.form.telephone.integer">-->
    <!--                                        {{ $t('message.integer', { n: 9 }) }}-->
    <!--                                    </b-form-invalid-feedback>-->
                                        <b-form-invalid-feedback v-if="!$v.form.telephone.minLength">
                                            {{ $t('message.minCharacters', { n: 9 }) }}
                                        </b-form-invalid-feedback>
                                        <b-form-invalid-feedback v-if="!$v.form.telephone.numericValidator">
                                            {{ $t('message.integer', { n: 9 }) }}
                                        </b-form-invalid-feedback>
                                        <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                            {{ getErrorsField('telephone') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>


                                <b-col sm="6">
                                    <div  :class="{ 'form-group--error': $v.form.email.$error}">
                                        
                                        <b-form-group
                                                id="email-group"
                                                :label="$t('message.email')"
                                                :title="$t('message.emailUsed')"
                                                label-for="email">
                                                <span class="text-warning">{{ $t('message.emailUsed') }}</span>
                                            <b-form-input
                                                    id="email"
                                                    v-model="$v.form.email.$model"
                                                    :state="$v.form.email.$dirty ? !(errorshasField('email') || $v.form.email.$error) : null"
                                                    type="email"
                                                    :placeholder="$t('message.emailUsed')"
                                                    @focus="clearErrorField('email')"
                                            ></b-form-input>

                                            <b-form-invalid-feedback v-if="!$v.form.email.required">
                                                {{ $t('message.requiredField') }}
                                            </b-form-invalid-feedback>

                                            <b-form-invalid-feedback v-else-if="!$v.form.email.email">
                                                {{ $t('message.emailNotValid') }}
                                            </b-form-invalid-feedback>

                                            <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                                {{ getErrorsField('email') }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                </b-col>

                            </b-row>

                            <b-row>

                                <b-col sm="2">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="sexe-group"
                                            :label="$t('message.gender')"
                                            label-for="sexe">
                                        <b-form-select
                                                id="sexe"
                                                v-model="$v.form.sexe.$model"
                                                :state="$v.form.sexe.$dirty ? !(errorshasField('sexe') || $v.form.sexe.$error) : null"
                                                :options="sexes"
                                                required
                                                @focus="clearErrorField('sexe')"
                                        ></b-form-select>

                                        <b-form-invalid-feedback v-if="!$v.form.sexe.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('sexe')">
                                            {{ getErrorsField('sexe') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                </b-col>

                                <b-col sm="4">
                                    <span  class="obligatoire">*</span>

                                    <i class="fas fa-question float-right" id="popover-target-1"></i>
                                    <b-popover target="popover-target-1" triggers="hover" placement="top">
                                        <template v-slot:title>{{$t('message.unknownDate')}}</template>
                                        {{$t('message.unknownDateText')}}
                                    </b-popover>
                                    <b-form-group
                                            id="dob-group"
                                            :label="$t('message.dob')"
                                            label-for="dob">
                                            <b-form-input
                                                id="dob"
                                                v-model="$v.form.date_de_naissance.$model"
                                                :state="$v.form.date_de_naissance.$dirty ? !(errorshasField('date_de_naissance') || $v.form.date_de_naissance.$error) : null"
                                                @focus="clearErrorField('date_de_naissance')"
                                                required
                                                type="date"
                                        ></b-form-input>
                                        
                                        <b-form-invalid-feedback v-if="errorshasField('date_de_naissance')">
                                            {{ getErrorsField('date_de_naissance') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-if="$v.form.date_de_naissance.$error">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>


                                    </b-form-group>

                                </b-col>

                                <b-col sm="6">

                                    <b-form-group
                                            id="nationalite-group"
                                            :label="$t('message.nationality')"
                                            label-for="nationalite"
                                    >
                                        <b-form-input
                                                id="nationalite"
                                                v-model="$v.form.nationalite.$model"
                                                :state="$v.form.nationalite.$dirty ? !(errorshasField('nationalite') || $v.form.nationalite.$error) : null"
                                                @focus="clearErrorField('nationalite')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="errorshasField('nationalite')">
                                            {{ getErrorsField('nationalite') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="!$v.form.nationalite.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                            </b-row>

                            <b-row>

                                <b-col sm="6">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="singleAddPatient-group"
                                            :label="$tc('message.countries', 1)"
                                            label-for="singleAddPatient">
                                        <!-- Options -->
                                       
                                        <b-form-select
                                                id="pays"
                                                v-model="$v.form.pays.$model"
                                                :state="$v.form.pays.$dirty ? !(errorshasField('pays') || $v.form.pays.$error) : null"
                                                :options="mCountries"
                                                required
                                                @focus="clearErrorField('pays')"
                                        >  </b-form-select>

                                        <b-form-invalid-feedback v-if="errorshasField('pays')">
                                            {{ getErrorsField('pays') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-if="$v.form.pays.$error">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>


                                    </b-form-group>

                                </b-col>

                                <b-col sm="6">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="ville-group"
                                            :label="$tc('message.cities', 1)"
                                            label-for="ville"
                                    >
                                        <b-form-input
                                                id="ville"
                                                v-model="$v.form.ville.$model"
                                                :state="$v.form.ville.$dirty ? !(errorshasField('ville') || $v.form.ville.$error) : null"
                                                @focus="clearErrorField('ville')"
                                                required
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="errorshasField('ville')">
                                            {{ getErrorsField('ville') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="!$v.form.ville.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">

                                    <b-form-group
                                            id="street-group"
                                            :label="$t('message.street')"
                                            label-for="street"
                                    >
                                        <b-form-input
                                                id="street"
                                                v-model="$v.form.quartier.$model"
                                                :state="$v.form.quartier.$dirty ? !(errorshasField('quartier') || $v.form.quartier.$error) : null"
                                                @focus="clearErrorField('quartier')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                            {{ getErrorsField('quartier') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="6">

                                    <b-form-group
                                            id="zipCode-group"
                                            :label="$t('message.zipCode')"
                                            label-for="zipCode"
                                    >
                                        <b-form-input
                                                id="zipCode"
                                                v-model="$v.form.code_postal.$model"
                                                :state="$v.form.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.code_postal.$error) : null"
                                                @focus="clearErrorField('code_postal')"
                                                type="number"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                            {{ getErrorsField('code_postal') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">

                                    <b-form-group
                                            id="address-group"
                                            :label="$t('message.address')"
                                            label-for="address"
                                    >
                                        <b-form-input
                                                id="address"
                                                v-model="$v.form.adresse.$model"
                                                :state="$v.form.adresse.$dirty ? !(errorshasField('adresse') || $v.form.adresse.$error) : null"
                                                @focus="clearErrorField('adresse')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                            {{ getErrorsField('adresse') }}
                                        </b-form-invalid-feedback>

                                        <!--                                    <b-form-invalid-feedback v-else-if="!$v.form.adresse.required">-->
                                        <!--                                        {{ $t('message.requiredField') }}-->
                                        <!--                                    </b-form-invalid-feedback>-->

                                    </b-form-group>

                                </b-col>
                                <b-col sm="6">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="niveau-group"
                                            :label="$t('message.niveauUrgence')"
                                            label-for="niveau">
                                            <b-form-select
                                                id="niveau"
                                                v-model="$v.form.niveau.$model"
                                                :state="$v.form.niveau.$dirty ? !(errorshasField('niveau') || $v.form.niveau.$error) : null"
                                                :options="niveaux"
                                                required
                                                @focus="clearErrorField('niveau')"
                                        >  </b-form-select>
                                        

                                    <b-form-invalid-feedback v-if="errorshasField('niveau')">
                                            {{ getErrorsField('niveau') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-if="$v.form.niveau.$error">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>
                                </b-col>

                                <b-col sm="4">
                                    <b-form-group
                                            id="package-group"
                                            :label="$t('message.cim')"
                                            label-for="package">
                                        <b-form-select
                                                id="package"
                                                v-model="$v.form.package.$model"
                                                :state="$v.form.package.$dirty ? !(errorshasField('package') || $v.form.package.$error) : null"
                                                :options="mCommandes"
                                                required
                                                @focus="clearErrorField('package')"
                                        >  </b-form-select>

                                        <b-form-invalid-feedback v-if="!$v.form.package.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('package')">
                                            {{ getErrorsField('package') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group
                                            id="lien-group"
                                            :label="$t('message.Lien')"
                                            label-for="lien">
                                        <b-form-select
                                                id="package"
                                                v-model="$v.form.lien.$model"
                                                :state="$v.form.lien.$dirty ? !(errorshasField('lien') || $v.form.lien.$error) : null"
                                                :options="liens"
                                                required
                                                @focus="clearErrorField('lien')"
                                        ></b-form-select>

                                        <b-form-invalid-feedback v-if="!$v.form.lien.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('lien')">
                                            {{ getErrorsField('lien') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group
                                            id="paye_par_affilie-group"
                                            :label="$t('message.paye_par_affilie')+'?'"
                                            label-for="paye_par_affilie">
                                            <div class="custom-control custom-radio custom-control-inline mt-2">
                                                <input type="radio" class="custom-control-input" v-model="$v.form.paye_par_affilie.$model" id="oui" checked value="Oui">
                                                <label class="custom-control-label" for="oui">Oui</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline mt-2">
                                                <input type="radio" class="custom-control-input" v-model="$v.form.paye_par_affilie.$model" id="non" value="Non">
                                                <label class="custom-control-label" for="non">Non</label>
                                            </div>
                                       <!--  <b-form-select
                                            id="paye_par_affilie"
                                            v-model="$v.form.paye_par_affilie.$model"
                                            :state="$v.form.paye_par_affilie.$dirty ? !(errorshasField('paye_par_affilie') || $v.form.paye_par_affilie.$error) : null"
                                            :options="paye_par_affilies"
                                            required
                                            @focus="clearErrorField('paye_par_affilie')"
                                        ></b-form-select> -->

                                        <b-form-invalid-feedback v-if="!$v.form.paye_par_affilie.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('paye_par_affilie')">
                                            {{ getErrorsField('paye_par_affilie') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <div>
                                        <!-- <b-form-select v-model="selected" :options="options"></b-form-select> -->
                                        <b-form-group
                                            id="selected-group"
                                            label-for="selected">
                                            <b-form-select
                                                id="selected"
                                                v-model="$v.form.selected.$model"
                                                :state="$v.form.selected.$dirty ? !(errorshasField('selected') || $v.form.selected.$error) : null"
                                                :options="options"
                                                required
                                                @focus="clearErrorField('selected')"
                                        >  </b-form-select>
                                        

                                    <b-form-invalid-feedback v-if="errorshasField('selected')">
                                            {{ getErrorsField('selected') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-if="$v.form.selected.$error">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>
                                        <!-- <div class="mt-3">Selected: <strong>{{ selected }}</strong></div> -->
                                    </div>
                                </b-col>
                                <div class="form-group col-md-12">
                                    <span class="obligatoire">*</span>
                                    <label for="plainte" class="typo__label">Plaintes</label>
                                    <multiselect v-model="form.plaintes" id="plainte" tag-placeholder="Ajouter une nouvelle plainte" :taggable="true" @tag="addTag" label="description" track-by="id" placeholder="Rechercher ou ajouter une plainte" :options="liste_plaintes" :multiple="true" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getMotifs">
                                        <template slot="clear" slot-scope="props">
                                            <div class="multiselect__clear" v-if="form.plaintes.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
                                        </template><span slot="noResult">Ajouter une nouvelle plainte</span>
                                    </multiselect>
                                    <small id="emailHelp" class="form-text text-danger">{{ errors.has('plaintes') ? "Les plaintes sont requises" : "" }}</small> 
                                     <b-form-invalid-feedback v-if="!$v.form.plaintes.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('plaintes')">
                                            {{ getErrorsField('plaintes') }}
                                    </b-form-invalid-feedback>
                                </div>
                            </b-row>
                        </fieldset>
                        <fieldset class="px-0 px-md-2">
                            <legend  class="w-auto title text-center">{{ $t('message.personnecontact') }}</legend>
                            <b-row>

                                <b-col sm="4">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="contact_name-group"
                                            :label="$t('message.lastName')"
                                            label-for="contact_name"
                                            description=""
                                    >
                                        <b-form-input
                                                id="contact_name"
                                                v-model="$v.form.contact_name.$model"
                                                :state="$v.form.contact_name.$dirty ? !(errorshasField('contact_name') || $v.form.contact_name.$error) : null"
                                                type="text"
                                                required
                                                placeholder=""
                                                @focus="clearErrorField('contact_name')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.contact_name.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('contact_name')">
                                            {{ getErrorsField('contact_name') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>

                                </b-col>
                                <b-col sm="4">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="contact_firstName-group"
                                            :label="$t('message.firstName')"
                                            label-for="contact_firstName"
                                            description=""
                                    >
                                        <b-form-input
                                                id="contact_firstName"
                                                v-model="$v.form.contact_firstName.$model"
                                                :state="$v.form.contact_firstName.$dirty ? !(errorshasField('contact_firstName') || $v.form.contact_firstName.$error) : null"
                                                type="text"
                                                required
                                                placeholder=""
                                                @focus="clearErrorField('contact_firstName')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.contact_firstName.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('contact_firstName')">
                                            {{ getErrorsField('contact_firstName') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>

                                </b-col>

                                <b-col sm="4">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="contact_phone-group"
                                            :label="$t('message.phoneNumber')"
                                            label-for="contact_phone">
                                        <!-- <b-form-input
                                                id="contact_phone"
                                                v-model="$v.form.contact_phone.$model"
                                                :state="$v.form.contact_phone.$dirty ? !(errorshasField('contact_phone') || $v.form.contact_phone.$error) : null"
                                                required
                                                placeholder=""
                                                @focus="clearErrorField('contact_phone')"
                                        ></b-form-input> -->
                                        <vue-tel-input
                                                id="contact_phone"
                                                v-model="$v.form.contact_phone.$model" 
                                                :state="$v.form.contact_phone.$dirty ? !(errorshasField('contact_phone') || $v.form.contact_phone.$error) : null"
                                                required
                                                placeholder=""
                                                @focus="clearErrorField('contact_phone')"
                                        ></vue-tel-input>
                                        
                                        <template v-if="$v.form.contact_phone.$error">
                                            <small id="telephone" v-if="!$v.form.contact_phone.required" class="form-text text-danger">Le telephone est obligatoire</small>
                                        </template>
                                        <template v-if="!$v.form.contact_phone.minLength">
                                            <small id="telephone" class="form-text text-danger">Minimum 9 chiffres</small>
                                        </template>
                                        <b-form-invalid-feedback v-if="!$v.form.contact_phone.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>
    <!--                                <b-form-invalid-feedback v-if="!$v.form.telephone.integer">-->
    <!--                                      {{ $t('message.integer', { n: 9 }) }}-->
    <!--                                 </b-form-invalid-feedback>-->
                                        <b-form-invalid-feedback v-if="!$v.form.contact_phone.minLength">
                                            {{ $t('message.minCharacters', { n: 9 }) }}
                                        </b-form-invalid-feedback>
                                        <b-form-invalid-feedback v-if="!$v.form.contact_phone.numericValidator">
                                            {{ $t('message.integer', { n: 9 }) }}
                                        </b-form-invalid-feedback>
                                        <b-form-invalid-feedback v-else-if="errorshasField('contact_phone')">
                                            {{ getErrorsField('contact_phone') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                </b-col>

                            </b-row>
                        </fieldset>

                        <!-- <b-row v-if="userIsMed == '1'">
                            <b-col sm="6" v-if="userIsMed ">
                                <div>
                                    <label class="form__label" for="hasDesc">{{$t('message.isMedPatner')}}</label>
                                    <div class="toggle">
                                        <input id="hasDesc2" type="checkbox" v-model="form.isMed"/>
                                        <label for="hasDesc2">
                                            <div class="toggle__switch"></div>
                                        </label>
                                    </div>
                                </div>
                            </b-col>
                        </b-row> -->

                    </b-container>

                    <b-container>
                        <div class="d-flex justify-content-center" v-if="is_loading">
                            <div class="loading"></div>
                        </div>
                        <b-container class="align-center addpatient" v-else>
                            <b-row class="justify-content-sm-center" v-if="can || hasAssistante">
                                <b-button @click="onSubmit" class="w-md-0" variant="primary">
                                    {{ $t('message.save') }}
                                </b-button>
                            </b-row>
                        </b-container>
                        
                    </b-container>
                </b-form>
            </div>
            <div class="card-body" v-else>
                    <b-row class="justify-content-sm-center">
                        <b-col  >
                            <strong class="text-red">Vous ne pouvez plus ajouter de patient veuillez acheter une nouvelle CIM</strong>
                            
                        </b-col>
                        <b-button @click="goToPaiement" variant="primary">
                                {{ $t('message.acheterUneAffiliation') }}
                        </b-button>
                    </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Vue from 'vue';
    import Swal from 'sweetalert2';
    import { required, email, minLength,integer,maxLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import Multiselect from 'vue-multiselect'
    import SlimSelect from 'slim-select';

    import VueTelInput from 'vue-tel-input';
    import 'vue-tel-input/dist/vue-tel-input.css';

    Vue.use(VueTelInput, {
        dropdownOptions: {
            showSearchBox: true,
            showDialCodeInSelection: true
        },
        inputOptions: {
            required: true,
            autofocus: true,
            showDialCode: true
        },
        invalidMsg:'Saisissez un numéro de téléphone correct',
        preferredCountries: ['cm', 'be', 'fr']
    });

    //import moment from "moment";
    window.$ = window.jQuery = window.jquery = require("jquery");
    import AppConfig from "../../constants/AppConfig";
    const numericValidator = string => (/^[0-9]+$/gi).test(string);

    export default {
        name: "AddPatient",
        props: ['circleView', 'showView'],
        components: { Multiselect },

        computed: {
            ...mapGetters(["countries", "subscribers", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasPraticienRole','hasMedecinControleRole',
                'hasSouscripteurRole',
                "userInstitutions",
                "questions",
                "commandes",
                'hasAssistante',
            ]),

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasSouscripteurRole || this.hasAssistante;
            },

            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });
                return cArray;
            },

            mQuestions: function() {
                let qArray = [];

                _.forOwn(this.questions, function(value, key) {
                    qArray.push({ text: value.intitule, value: value.id });
                });

                return qArray;
            },

            mCommandes: function (){
                let offres = [];
                // console.log("this.commandes ", this.commandes)
                if( !_.isUndefined(this.commandes) && !_.isNull(this.commandes)){
                _.forOwn(this.commandes, function(value) {
                    if(value.nombre_restant >=0){
                        offres.push({ text: value.type_contrat.description_fr, value: value.id, id: value.type_contrat.offre_id });
                    }
                });
                }

                return offres;
            },

            mSubscribers: function() {
                let sArray = [];

                _.forOwn(this.subscribers, function(value, key) {
                    if (!_.isNull(value.user)){
                        let prenom  = value.user.prenom ? value.user.prenom : "";
                        prenom =  prenom.toLowerCase();
                        let fullName = (value.user.nom).toUpperCase()+ " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        sArray.push({ text: fullName, value: value.user.id });
                    }
                });

                return sArray;
            },
        },

        data() {
            return {
                liste_plaintes: [],
                loading: false,
                selected: null,
                options: [
                    { value: null, text: "Par quel canal avez-vous entendu parler de Medicasure pour la 1ère fois ?" },
                    { value: 1, text: "Recommandattion d'un client" },
                    { value: 2, text: "WhatsApp" },
                    { value: 3, text: "Website" },
                    { value: 4, text: "Facebook" },
                    { value: 5, text: "Connaissance promoteur" },
                    // { value: 'b', text: 'Selected Option', disabled: true },
                ],
                item:{text:'Selectionner un souscripteur ci-dessous',value:0},
                niveaux: [{ text: 1, value: 1 }, { text: 2, value: 2 }, { text: 3, value: 3 }, { text: 4, value: 4 }, { text: 5, value: 5 }],
                searchTerm : '',
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                form: {
                    isMed: true,
                    quartier:'',
                    code_postal:'',
                    nom: '',
                    prenom: '',
                    adresse: '',
                    lien: '',
                    paye_par_affilie: 'Non',
                    // souscripteur: null,
                    telephone: '',
                    contact_phone:'',
                    contact_name: '',
                    contact_firstName:'',
                    email: JSON.parse(localStorage.getItem('user')).email,
                    package: this.$route.params.id,
                    sexe: '',
                    date_de_naissance: '',
                    nationalite: '',
                    ville: '',
                    pays: 'Cameroon',
                    institution:[],
                    niveau: null,
                    selected: null,
                    plaintes: [],
                    is_loading: false

                },
                hasPatientEmail: false,
                sexes: [
                    { value: 'F', text: this.$i18n.t('message.female') },
                    { value: 'M', text: this.$i18n.t('message.male') }
                ],
                liens: [
                    { value: '1', text: "Amis" },
                    { value: '2', text: "Connaissance" },
                    { value: '3', text: "Parent" },
                    { value: '4', text: "Enfant" },
                ],
                paye_par_affilies: [
                    { value: 'oui', text: "Oui" },
                    { value: 'non', text: "Non" }
                ],
                mSubscribersFilter:[],
                show: true,

                mSubscribersColumns: [
                    {
                        field: 'text',
                        label: this.$i18n.t('message.name'),
                    },
                ],
            }
        },
        watch:{
            hasPatientEmail:function(oldValue,newValue){
                if(newValue == false){
                    this.form.email = "";
                }
            },

            searchTerm:function (newValue, oldValue) {
                if (!this.hasPatientRole){
                    if (newValue.trim().length ==0){
                        this.mSubscribersFilter = [];
                    }else{
                        this.mSubscribersFilter = this.mSubscribers;
                    }
                }else{
                    this.mSubscribersFilter =this.mSubscribers;
                }
            }


        },

        methods: {
            hasHistory () { return window.history.length > 2 },
            checkIfProfileComplete(){
                //this.$bvModal.show('modal-scoped');
                let user = JSON.parse(localStorage.getItem('user'));
                    if(user.souscripteur.sexe == ''){
                        //alert("Veuillez completer votre profile avant de continuer");
                        this.$bvModal.show('modal-scoped');
                     }
               
            },
            addTag (newTag) {
                const tag = {
                    id: "item_"+newTag,
                    description: newTag
                }
                this.liste_plaintes.push(tag)
                this.form.plaintes.push(tag)
            },
            getMotifs(motif){
                this.loading = true;
                fetch(AppConfig.apiUrl+`/search/motif/${motif}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                .then(res => {
                    this.loading = false;
                    this.liste_plaintes = res.motifs.map(item => ({id: item.id, description: item.description})).filter(item => item.description != "" && item.description != "[object Object]");
                }).catch(error => {
                    console.log('error ', error);
                })
            },
            clearSouscripteur(){
                this.item = {};
            },

            onSubscriberClick(params){
                // this.$router.push({ name: 'patient', params: { patient: params.row.value } });
                this.item = {};
                this.item = {text:params.row.text,value:params.row.value};
                this.searchTerm = '';
            },

            itemSelected:function(item){
                //console.log(item);
            },
            itemChange:function(item){
                //console.log(item );
            },

            goToPaiement :function(){

               this.$router.push({ name: 'paiement', params: { identifiant: (JSON.parse(localStorage.getItem('user')))['slug'] } });

            },

            getQuestionsList() {
                let args = {
                };

                this.$store.dispatch('getQuestions', { args : args });
            },

            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },

            getCommandes: function() {
                let args = {
                    souscripteur: (JSON.parse(localStorage.getItem('user')))['id']
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                this.$store.dispatch('getCommandes', { args, errorMessages });
            },
            getLiens() {
            let self = this;
            fetch(AppConfig.apiUrl + "/liens", {
                method: "GET",
                headers: {
                "Content-Type": "application/json;charset=utf-8",
                },
            })
                .then(function (response) {
                return response.json();
                })
                .then(function (result) {
                    let qArray = [];

                    _.forOwn(result.liens, function(value, key) {
                        qArray.push({ text: value.fr_description, value: value.id });
                    });

                    self.liens = qArray;
                    self.form.lien = qArray[0].value;
                })
                .catch(function (error) {
                console.error("Error:", error);
                });
            },
            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();
                let args = {
                        nom: this.form.nom,
                        prenom: this.form.prenom,
                        souscripteur_id: (JSON.parse(localStorage.getItem('user')))['id'],
                        email: this.form.email,
                        telephone: this.form.telephone,
                        sexe: this.form.sexe,
                        date_de_naissance: this.form.date_de_naissance,
                        nationalite: this.form.nationalite,
                        ville: this.form.ville,
                        adresse: this.form.adresse,
                        commande_id:  this.form.package,
                        pays: this.form.pays,
                        urgence: this.form.niveau,
                        selected: this.form.selected,
                        plaintes: this.form.plaintes.map(item => item.id),
                        contact_firstName: this.form.contact_firstName,
                        contact_name: this.form.contact_name,
                        contact_phone: this.form.contact_phone,
                        nom_pere:'',
                        nom_mere: '',
                        paye_par_affilie: this.form.paye_par_affilie,
                        lien_parente: this.form.lien,
                        quartier:this.form.quartier,
                        code_postal:this.form.code_postal
                };
                // console.log("args ", args)
                if(!this.$v.$invalid ) {
                    //  console.log("valide ", args)

                    let successMessage = this.$i18n.t('message.patientCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };
                    this.is_loading = true;
                    this.$store.dispatch('createPatientSouscripteur', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                            this.is_loading = false;
                        }).catch(() => {
                            this.is_loading = false;
                        });
                    
                }
            },

            onReset: function(evt) {
                evt.preventDefault();
                // Reset our form values
                this.form.nom = '';
                this.form.prenom = '';
                this.form.adresse = '';
                this.form.souscripteur = '';
                this.form.email = '';
                this.form.telephone = '';
                this.form.sexe = '';
                this.form.date_de_naissance = '';
                this.form.nationalite = '';
                this.form.ville = '';
                this.form.pays = '';
                this.form.paye_par_affilie = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },

        },

        validations() {
            
                return {
                    form: {

                        niveau: {
                            required,
                        },
                        selected: {
                            required,
                        },

                        nom: {
                            required
                        },
                        contact_name: {
                            required
                        },
                        contact_firstName:{
                            required
                        },
                        contact_phone: {
                            required,
                            minLength: minLength(9),
                            numericValidator
                        },

                        prenom: {
                            //
                        },

                        telephone: {
                            required,
                            minLength: minLength(9),
                        },
                        email:{
                            required,
                            email
                        },
                        plaintes: {
                            required
                        },
                        niveau: {
                            required,
                            integer
                        },
                        selected: {
                            required,
                            integer
                        },
                        contact_name: {
                            required
                        },
                        contact_firstName:{
                            required
                        },
                        contact_phone: {
                            required,
                            minLength: minLength(9),
                            numericValidator
                        },
                        lien:{
                            required
                        },
                        paye_par_affilie : {
                            required
                        },
                        sexe: {
                            required
                        },
                        package:{
                            required,
                        },
                        date_de_naissance: {
                            required
                        },
                        nationalite: {
                            // required
                        },
                        ville: {
                            required
                        },
                        pays: {
                            required
                        },
                        adresse: {
                            // required
                        },
                        quartier:{

                        },
                        code_postal:{

                        }
                    }
                }
            

        },

        mounted() {
            // Retrieve list of countries
            this.getCountries();

            // Retrieve list of subscribers
            this.getCommandes();

            // Retrieve list of question
            this.getQuestionsList();

            // liens de parenté
            this.getLiens();

            new SlimSelect({
                select: '#singleAddPatient',
                placeholder: 'Select country'
            }) ;

            new SlimSelect({
                select: '#niveau',
                placeholder: 'Select secret question'
            }) ;
            new SlimSelect({
                select: '#selected',
                placeholder: 'Select secret question'
            }) ;
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
